import React from 'react';
import { Numbers } from '@buddy-technology/buddy_helpers';
import { unFlatten } from '@buddy-technology/ion-helpers';
import { useEventContext } from '../context/EventContext';
import { RenderedView, StepThroughNav, IF } from './helpers';
import Quote from './Quote';

function OfferOnly({
	hideFields,
	viewData,
	quoteViewData,
	quoteRequirements,
	partnerId,
	getValues,
	onAddToCart,
	onRemoveFromCart,
	shouldHideBack,
	stage,
	...sharedProps
}) {
	const premium = getValues('policy::premiumTotal');
	const { eventCallback } = useEventContext();

	const {
		id,
		backButtonLabel,
	} = viewData;

	const {
		navigate,
	} = sharedProps;

	const handleChange = ({ target: { checked } }) => {
		const eventDetails = {
			timestamp: Date.now(),
			viewId: 'offer-only',
			premium: Numbers.toUSD(premium),
			partnerId,
		};
		const callback = checked ? onAddToCart : onRemoveFromCart;
		const eventType = checked ? 'onAddToCart' : 'onRemoveFromCart';
		const payload = unFlatten(getValues());
		eventCallback(eventType, eventDetails);
		callback(payload);
	};

	return (
		<div id="offer-only-container">
			<RenderedView
				getValues={getValues}
				{...viewData}
				{...sharedProps}
				showNav={false}
			/>
			<Quote
				id="quote-view"
				offerOnlyMode
				partnerId={partnerId}
				quoteRequirements={quoteRequirements}
				getValues={getValues}
				stage={stage}
				{...quoteViewData}
				{...sharedProps}
				showNav={false}
			/>

			<div id="offer-only-input-wrapper">
				<input
					id="offer-only-checkbox"
					className="input form-checkbox"
					type="checkbox"
					data-testid="checkbox"
					onChange={handleChange}
				/>
				<label
					id="offer-only-checkbox-label"
					htmlFor="offer-only-checkbox"
				>
					{viewData?.optInLabel}
				</label>
			</div>
			<IF condition={!shouldHideBack}>
				<StepThroughNav
					backButtonLabel={backButtonLabel}
					navigate={navigate}
					hideNext
					status={id}
				/>
			</IF>
		</div>
	);
}

export default OfferOnly;
